import { render, staticRenderFns } from "./ProgrammeView.vue?vue&type=template&id=1616fe2c&"
import script from "./ProgrammeView.vue?vue&type=script&lang=js&"
export * from "./ProgrammeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports